// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AcUS","colMin":"styles_colMin__17Jj2"};